/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerListAccountUsersQueryResponse, TrimbleDiagnosticsControllerListAccountUsersPathParams, TrimbleDiagnosticsControllerListAccountUsers400, TrimbleDiagnosticsControllerListAccountUsers401, TrimbleDiagnosticsControllerListAccountUsers403, TrimbleDiagnosticsControllerListAccountUsers404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerListAccountUsers";

function getTrimbleDiagnosticsControllerListAccountUsersUrl(iamAccountId: TrimbleDiagnosticsControllerListAccountUsersPathParams["iamAccountId"]) {
  const res = { method: 'GET', url: `/api/v1/trimble-account-users-diagnostics/${iamAccountId}` as const }  
  return res
}

/**
 * @summary List the Trimble IAM users in an account
 * {@link /api/v1/trimble-account-users-diagnostics/:iamAccountId}
 */
export async function trimbleDiagnosticsControllerListAccountUsers(iamAccountId: TrimbleDiagnosticsControllerListAccountUsersPathParams["iamAccountId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerListAccountUsersQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerListAccountUsers400 | TrimbleDiagnosticsControllerListAccountUsers401 | TrimbleDiagnosticsControllerListAccountUsers403 | TrimbleDiagnosticsControllerListAccountUsers404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerListAccountUsersUrl(iamAccountId).url.toString(), ... requestConfig })  
  return res.data
}